// extracted by mini-css-extract-plugin
export default {"questionLabel":"LikertQuestion_questionLabel__RoaZt"};